const ProfileUnderReviewCard = () => (
  <div className="w-full max-w-2xl rounded-2xl bg-white p-8 shadow-xl md:p-12">
    <div className="mb-6 flex justify-center">
      <div
        className="flex h-24 w-24 items-center justify-center rounded-full"
        style={{ backgroundColor: '#e3f2fd' }}
      >
        <svg
          className="h-12 w-12"
          style={{ color: '#1464AE' }}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
    </div>

    <h1 className="mb-4 text-center text-3xl font-bold text-gray-900 md:text-4xl">
      Profile Under Review
    </h1>

    <p className="mb-8 text-center text-lg leading-relaxed text-gray-600">
      Thank you for submitting your tutor profile! Our trusted partner is
      currently reviewing your application to ensure the highest quality
      standards for our platform.
    </p>

    <div
      className="mb-8 rounded-r-lg p-6"
      style={{
        backgroundColor: '#e3f2fd',
        borderLeft: '4px solid #1464AE',
      }}
    >
      <div className="flex items-start">
        <svg
          className="h-6 w-6 flex-shrink-0"
          style={{ color: '#1464AE' }}
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clipRule="evenodd"
          />
        </svg>
        <div className="ml-4">
          <h2
            className="mb-2 text-sm font-semibold"
            style={{ color: '#1464AE' }}
          >
            What happens next?
          </h2>
          <ul className="space-y-2 text-sm" style={{ color: '#1464AE' }}>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                Our trusted partner will review your profile, credentials, and
                submitted documents
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>This process typically takes 5-7 business days.</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                You will receive an email when the review of your application
                is complete
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                After approval, you can begin the onboarding process.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className="text-center">
      <a
        href="mailto:support@tutorscene.com"
        className="inline-flex items-center font-semibold transition-opacity hover:opacity-80"
        style={{ color: '#1464AE' }}
      >
        <svg
          className="mr-2 h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2v10a2 2 0 002 2z"
          />
        </svg>
        Have Questions?
      </a>
    </div>
  </div>
);

export default ProfileUnderReviewCard;
